'use client';

import { Button } from '@headlessui/react';
import { ClipLoader } from 'react-spinners';
import { HiOutlineArrowRight } from 'react-icons/hi';
import { Plus } from 'lucide-react';

interface LoaderButtonProps {
  isLoading?: boolean;
  onClick?: () => void;
  isMobile?: boolean;
  className?: string;
  text?: string;
  disabled?: boolean;
  type?: 'submit' | 'button' | 'reset';
  icon?: boolean;
  form?: string;
  plus?: boolean;
}

export const LoaderButton = ({
  isLoading,
  onClick,
  isMobile = false,
  className = '',
  disabled,
  type = 'submit',
  text = 'Next',
  icon,
  form,
  plus,
}: LoaderButtonProps) => {
  return (
    <Button
      type={type}
      form={form}
      className={`mt-6 button w-full sm:w-fit ${
        disabled ? 'button-inactive' : 'button-active'
      } ${className}`}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <div className="flex justify-center items-center">
          <ClipLoader size={20} color="#ffffff" loading={true} />
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2 text-sm">
          {plus && <Plus size={14} />} {text} {icon && <HiOutlineArrowRight />}
        </div>
      )}
    </Button>
  );
};
